import {Slideshow, SlideshowEvents} from './slideshow'
import {inject, injectable} from 'inversify'
import {Synchroniser} from './Synchroniser'
import {PubSub} from "./Core/PubSub";
import {Voiceover} from "@/voiceover";
import {Caption} from "@/Core/SlideshowData";

@injectable()
export class ClosedCaptionsService {
    private currentCaptions: Caption[] = [];
    private currentReaderText: Caption[] = [];
    private currentCaptionIndex: number|null = null;

    public constructor(
        @inject("Slideshow") private slideshow: Slideshow,
        @inject("PubSub") private pubSub: PubSub,
        @inject("Synchroniser")
        private sync: Synchroniser,
        @inject("Voiceover")
        private voiceover: Voiceover,
    ) {
        pubSub.subscribeToEvent(SlideshowEvents.Load, () => this.load());
        pubSub.subscribeToEvent(SlideshowEvents.SlideEntered, () => {
            let slide = slideshow.currentSlide;
            this.currentCaptions = slide.captions.filter(c => !c.isReaderModeOnly);
            this.currentReaderText = slide.captions.map(x => x);
            this.currentCaptionIndex = null;
            this.updateCaption();
            for (let a of slide.announcements) {
                this.voiceover.announceAfterCurrentSlideVoiceover(a);
            }
        });
    }

    load(): Promise<void> {
        this.pubSub.subscribeToEvent(SlideshowEvents.Tick, () => this.update());
        return Promise.resolve();
    }


    captionUpdates: ((caption: Caption|null) => any)[] = [];

    onCaptionUpdate(func: (caption: Caption|null) => any) {
        this.captionUpdates.push(func);
    }

    getSlideDescriptionForCurrentSlide(): SlideDescription[] {
        return this.currentReaderText;
    }

    private update() {
        let progress = this.sync.getSlideProgress();

        for (let i = 0; i < this.currentCaptions.length; i++) {
            let c = this.currentCaptions[i];
            if (c.start <= progress && c.end > progress) {
                if (this.currentCaptionIndex === i) return;
                this.currentCaptionIndex = i;
                this.updateCaption();
                return;
            }
        }

        if (this.currentCaptionIndex != null) {
            this.currentCaptionIndex = null;
            this.updateCaption();
        }
    }

    private updateCaption() {
        let currentCaption: Caption|null = null;
        if (this.currentCaptionIndex != null)
            currentCaption = this.currentCaptions[this.currentCaptionIndex];

        for (let c of this.captionUpdates) {
            c(currentCaption);
        }
    }
}

export interface SlideText {
    captions: SlideDescription[];
    announcements: AnnouncementItem[];
    actions: SlideAction[];
}

export type SlideDescription = Caption|ReaderModeItem;


export interface ReaderModeItem {
    isReaderModeOnly: true;
    text: string;
}

export interface AnnouncementItem {
    text: string;
}

export interface SlideAction {
    text: string;
    slideId: string;
}

